// // File Location: src/services/hospitalService.js (Updated)

// import {
//   collection,
//   addDoc,
//   doc,
//   updateDoc,
//   getDoc,
//   getDocs,
//   query,
//   where,
//   orderBy,
//   limit,
//   setDoc,
// } from "firebase/firestore";
// import {
//   ref,
//   uploadBytes,
//   getDownloadURL,
//   deleteObject,
// } from "firebase/storage";
// import { createUserWithEmailAndPassword } from "firebase/auth";
// import { db, storage, auth } from "./firebaseConfig";

// // Hospital registration service
// export const registerHospital = async (hospitalData, documents) => {
//   try {
//     // Upload all documents first
//     const documentUrls = {};
//     const uploadPromises = [];

//     for (const [docType, file] of Object.entries(documents)) {
//       if (file) {
//         const uploadPromise = uploadDocument(
//           file,
//           docType,
//           hospitalData.hospitalName
//         );
//         uploadPromises.push(
//           uploadPromise.then((url) => {
//             documentUrls[docType] = {
//               url,
//               fileName: file.name,
//               size: file.size,
//               uploadedAt: new Date(),
//             };
//           })
//         );
//       }
//     }

//     // Wait for all document uploads to complete
//     await Promise.all(uploadPromises);

//     // Prepare hospital data for Firestore
//     const hospitalRecord = {
//       // Basic Information
//       hospitalName: hospitalData.hospitalName,
//       address: hospitalData.address,
//       city: hospitalData.city,
//       state: hospitalData.state,
//       pincode: hospitalData.pincode,
//       phone: hospitalData.phone,
//       email: hospitalData.email,
//       website: hospitalData.website || "",

//       // Hospital Details
//       numberOfBeds: parseInt(hospitalData.numberOfBeds),
//       facilities: hospitalData.facilities,
//       specialities: hospitalData.specialities,

//       // Representative Information
//       representative: {
//         name: hospitalData.representativeName,
//         designation: hospitalData.designation,
//         email: hospitalData.representativeEmail,
//         phone: hospitalData.representativePhone,
//       },

//       // MD Information
//       managingDirector: {
//         name: hospitalData.mdName,
//         contact: hospitalData.mdContact,
//         email: hospitalData.mdEmail || "",
//       },

//       // Account Information
//       accountEmail: hospitalData.accountEmail,
//       // Note: Password will be stored separately in Firebase Auth

//       // Bank Details
//       bankDetails: {
//         bankName: hospitalData.bankName,
//         accountNumber: hospitalData.accountNumber,
//         ifscCode: hospitalData.ifscCode,
//         accountHolderName: hospitalData.accountHolderName,
//       },

//       // Documents
//       documents: documentUrls,

//       // System fields
//       status: "pending", // pending, approved, rejected
//       applicationId: generateApplicationId(),
//       submittedAt: new Date(),
//       createdAt: new Date(),
//       updatedAt: new Date(),
//       isActive: false, // Will be set to true when approved
//       approvedBy: null,
//       approvedAt: null,
//       rejectionReason: null,
//     };

//     // Save to Firestore
//     const docRef = await addDoc(
//       collection(db, "hospitalApplications"),
//       hospitalRecord
//     );

//     return {
//       success: true,
//       applicationId: hospitalRecord.applicationId,
//       docId: docRef.id,
//       message: "Hospital registration submitted successfully!",
//     };
//   } catch (error) {
//     console.error("Error registering hospital:", error);
//     return {
//       success: false,
//       error: error.message || "Failed to register hospital",
//     };
//   }
// };

// // Upload document to Firebase Storage
// export const uploadDocument = async (file, docType, hospitalName) => {
//   try {
//     const timestamp = Date.now();
//     const fileName = `${docType}_${timestamp}_${file.name}`;
//     const storagePath = `hospitals/${hospitalName.replace(
//       /\s+/g,
//       "_"
//     )}/documents/${fileName}`;

//     const storageRef = ref(storage, storagePath);
//     const snapshot = await uploadBytes(storageRef, file);
//     const downloadURL = await getDownloadURL(snapshot.ref);

//     return downloadURL;
//   } catch (error) {
//     console.error("Error uploading document:", error);
//     throw new Error(`Failed to upload ${docType}: ${error.message}`);
//   }
// };

// // Generate unique application ID
// const generateApplicationId = () => {
//   const prefix = "SAM";
//   const timestamp = Date.now().toString().slice(-8);
//   const random = Math.random().toString(36).substr(2, 4).toUpperCase();
//   return `${prefix}${timestamp}${random}`;
// };

// // Get all hospital applications (for admin)
// export const getHospitalApplications = async (status = null) => {
//   try {
//     let q = collection(db, "hospitalApplications");

//     if (status) {
//       q = query(q, where("status", "==", status));
//     }

//     q = query(q, orderBy("submittedAt", "desc"));

//     const querySnapshot = await getDocs(q);
//     const applications = [];

//     querySnapshot.forEach((doc) => {
//       applications.push({
//         id: doc.id,
//         ...doc.data(),
//       });
//     });

//     return {
//       success: true,
//       applications,
//     };
//   } catch (error) {
//     console.error("Error fetching hospital applications:", error);
//     return {
//       success: false,
//       error: error.message,
//       applications: [],
//     };
//   }
// };

// // Get single hospital application
// export const getHospitalApplication = async (applicationId) => {
//   try {
//     const q = query(
//       collection(db, "hospitalApplications"),
//       where("applicationId", "==", applicationId)
//     );

//     const querySnapshot = await getDocs(q);

//     if (querySnapshot.empty) {
//       return {
//         success: false,
//         error: "Application not found",
//       };
//     }

//     const doc = querySnapshot.docs[0];
//     return {
//       success: true,
//       application: {
//         id: doc.id,
//         ...doc.data(),
//       },
//     };
//   } catch (error) {
//     console.error("Error fetching hospital application:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Approve hospital application
// export const approveHospitalApplication = async (
//   applicationId,
//   approvedBy,
//   password
// ) => {
//   try {
//     // Get application data
//     const appResult = await getHospitalApplication(applicationId);
//     if (!appResult.success) {
//       throw new Error("Application not found");
//     }

//     const application = appResult.application;

//     // Create Firebase Auth user
//     const userCredential = await createUserWithEmailAndPassword(
//       auth,
//       application.accountEmail,
//       password
//     );

//     // Create user document in users collection
//     const userData = {
//       uid: userCredential.user.uid,
//       email: application.accountEmail,
//       role: "Hospital",
//       hospitalId: application.id,
//       hospitalName: application.hospitalName,
//       isActive: true,
//       createdAt: new Date(),
//       profile: {
//         name: application.representative.name,
//         phone: application.representative.phone,
//         designation: application.representative.designation,
//       },
//     };

//     await setDoc(doc(db, "users",userCredential.user.uid), userData);

//     // Update hospital application status
//     const hospitalRef = doc(db, "hospitalApplications", application.id);
//     await updateDoc(hospitalRef, {
//       status: "approved",
//       isActive: true,
//       approvedBy: approvedBy,
//       approvedAt: new Date(),
//       updatedAt: new Date(),
//       authUserId: userCredential.user.uid,
//     });

//     return {
//       success: true,
//       message: "Hospital approved successfully",
//       userId: userCredential.user.uid,
//     };
//   } catch (error) {
//     console.error("Error approving hospital:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Reject hospital application
// export const rejectHospitalApplication = async (
//   applicationId,
//   rejectedBy,
//   reason
// ) => {
//   try {
//     const appResult = await getHospitalApplication(applicationId);
//     if (!appResult.success) {
//       throw new Error("Application not found");
//     }

//     const hospitalRef = doc(
//       db,
//       "hospitalApplications",
//       appResult.application.id
//     );
//     await updateDoc(hospitalRef, {
//       status: "rejected",
//       rejectedBy: rejectedBy,
//       rejectedAt: new Date(),
//       rejectionReason: reason,
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       message: "Hospital application rejected",
//     };
//   } catch (error) {
//     console.error("Error rejecting hospital:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };
// export const requestAdditionalDocuments = async (
//   applicationId,
//   requestedBy,
//   message,
//   documents
// ) => {
//   try {
//     // First get the application
//     const applicationResult = await getHospitalApplication(applicationId);
//     if (!applicationResult.success) {
//       return applicationResult;
//     }

//     const application = applicationResult.application;

//     // Create a document request record
//     const requestData = {
//       applicationId: applicationId,
//       hospitalId: application.id,
//       hospitalName: application.hospitalName,
//       requestedBy: requestedBy,
//       message: message,
//       requestedDocuments: documents,
//       status: "pending",
//       createdAt: new Date(),
//       updatedAt: new Date(),
//     };

//     // Add to document requests collection
//     await addDoc(collection(db, "documentRequests"), requestData);

//     // Update application with request status
//     const applicationDoc = doc(db, "hospitalApplications", application.id);
//     await updateDoc(applicationDoc, {
//       hasDocumentRequest: true,
//       lastDocumentRequestAt: new Date(),
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       message: "Document request sent successfully",
//     };
//   } catch (error) {
//     console.error("Error requesting additional documents:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };
// // Get application statistics for admin dashboard
// export const getApplicationStats = async () => {
//   try {
//     const hospitalApplicationsRef = collection(db, "hospitalApplications");
//     const patientApplicationsRef = collection(db, "patientApplications");

//     // Get hospital application counts
//     const totalHospitalQuery = await getDocs(hospitalApplicationsRef);
//     const pendingHospitalQuery = await getDocs(
//       query(hospitalApplicationsRef, where("status", "==", "pending"))
//     );
//     const approvedHospitalQuery = await getDocs(
//       query(hospitalApplicationsRef, where("status", "==", "approved"))
//     );
//     const rejectedHospitalQuery = await getDocs(
//       query(hospitalApplicationsRef, where("status", "==", "rejected"))
//     );

//     // Get patient application counts
//     const totalPatientQuery = await getDocs(patientApplicationsRef);
//     const pendingPatientQuery = await getDocs(
//       query(patientApplicationsRef, where("status", "==", "submitted"))
//     );
//     const approvedPatientQuery = await getDocs(
//       query(patientApplicationsRef, where("status", "==", "approved"))
//     );

//     // Calculate this month applications
//     const currentMonth = new Date();
//     currentMonth.setDate(1);
//     currentMonth.setHours(0, 0, 0, 0);

//     const thisMonthQuery = await getDocs(
//       query(hospitalApplicationsRef, where("submittedAt", ">=", currentMonth))
//     );

//     // Calculate average approval time (simplified calculation)
//     const approvedApps = approvedHospitalQuery.docs;
//     let totalApprovalTime = 0;
//     let approvalCount = 0;

//     approvedApps.forEach((doc) => {
//       const data = doc.data();
//       if (data.submittedAt && data.approvedAt) {
//         const submittedDate = data.submittedAt.toDate();
//         const approvedDate = data.approvedAt.toDate();
//         const timeDiff = (approvedDate - submittedDate) / (1000 * 60 * 60 * 24); // in days
//         totalApprovalTime += timeDiff;
//         approvalCount++;
//       }
//     });

//     const averageApprovalTime =
//       approvalCount > 0 ? Math.round(totalApprovalTime / approvalCount) : 0;

//     return {
//       success: true,
//       stats: {
//         // Hospital statistics
//         totalApplications: totalHospitalQuery.size,
//         pendingApplications: pendingHospitalQuery.size,
//         approvedHospitals: approvedHospitalQuery.size,
//         rejectedApplications: rejectedHospitalQuery.size,
//         thisMonthApplications: thisMonthQuery.size,
//         averageApprovalTime: averageApprovalTime,

//         // Patient application statistics
//         totalPatientApplications: totalPatientQuery.size,
//         pendingPatientApplications: pendingPatientQuery.size,
//         approvedPatientApplications: approvedPatientQuery.size,
//       },
//     };
//   } catch (error) {
//     console.error("Error fetching application stats:", error);
//     return {
//       success: false,
//       error: error.message,
//       stats: {
//         totalApplications: 0,
//         pendingApplications: 0,
//         approvedHospitals: 0,
//         rejectedApplications: 0,
//         thisMonthApplications: 0,
//         averageApprovalTime: 0,
//         totalPatientApplications: 0,
//         pendingPatientApplications: 0,
//         approvedPatientApplications: 0,
//       },
//     };
//   }
// };

// // Get approved hospitals (for dropdowns, etc.)
// export const getApprovedHospitals = async () => {
//   try {
//     const q = query(
//       collection(db, "hospitalApplications"),
//       where("status", "==", "approved"),
//       where("isActive", "==", true),
//       orderBy("hospitalName")
//     );

//     const querySnapshot = await getDocs(q);
//     const hospitals = [];

//     querySnapshot.forEach((doc) => {
//       hospitals.push({
//         id: doc.id,
//         hospitalName: doc.data().hospitalName,
//         city: doc.data().city,
//         state: doc.data().state,
//         specialities: doc.data().specialities,
//       });
//     });

//     return {
//       success: true,
//       hospitals,
//     };
//   } catch (error) {
//     console.error("Error fetching approved hospitals:", error);
//     return {
//       success: false,
//       error: error.message,
//       hospitals: [],
//     };
//   }
// };

// // Update hospital profile
// export const updateHospitalProfile = async (hospitalId, updateData) => {
//   try {
//     const hospitalRef = doc(db, "hospitalApplications", hospitalId);
//     await updateDoc(hospitalRef, {
//       ...updateData,
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       message: "Hospital profile updated successfully",
//     };
//   } catch (error) {
//     console.error("Error updating hospital profile:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };

// // Delete document from storage
// export const deleteDocument = async (documentUrl) => {
//   try {
//     const storageRef = ref(storage, documentUrl);
//     await deleteObject(storageRef);
//     return { success: true };
//   } catch (error) {
//     console.error("Error deleting document:", error);
//     return { success: false, error: error.message };
//   }
// };

// // Get recent activities for admin dashboard
// export const getRecentActivities = async (limit = 10) => {
//   try {
//     const hospitalQuery = query(
//       collection(db, "hospitalApplications"),
//       orderBy("updatedAt", "desc"),
//       limit(limit)
//     );

//     const querySnapshot = await getDocs(hospitalQuery);
//     const activities = [];

//     querySnapshot.forEach((doc) => {
//       const data = doc.data();
//       activities.push({
//         id: doc.id,
//         type: "hospital",
//         action: data.status,
//         hospitalName: data.hospitalName,
//         timestamp: data.updatedAt,
//         details: data,
//       });
//     });

//     return {
//       success: true,
//       activities,
//     };
//   } catch (error) {
//     console.error("Error fetching recent activities:", error);
//     return {
//       success: false,
//       error: error.message,
//       activities: [],
//     };
//   }
// };

// export const deactivateHospital = async (hospitalId, deactivatedBy, reason) => {
//   try {
//     const hospitalDoc = doc(db, "hospitalApplications", hospitalId);
//     await updateDoc(hospitalDoc, {
//       isActive: false,
//       deactivatedBy: deactivatedBy,
//       deactivatedAt: new Date(),
//       deactivationReason: reason,
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       message: "Hospital deactivated successfully",
//     };
//   } catch (error) {
//     console.error("Error deactivating hospital:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };
// File Location: src/services/hospitalService.js (Updated with Lead Generator Referral)

import {
  collection,
  addDoc,
  doc,
  updateDoc,
  getDoc,
  getDocs,
  query,
  where,
  orderBy,
  limit,
  setDoc,
  runTransaction,
  getFirestore,
  serverTimestamp
} from "firebase/firestore";
import {
  ref,
  uploadBytes,
  getDownloadURL,
  deleteObject,
} from "firebase/storage";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { db, storage, auth, secondaryAuth } from "./firebaseConfig";

// Hospital registration service with lead generator referral support
export const registerHospital = async (hospitalData, documents) => {
  try {
    // Upload all documents first
    const documentUrls = {};
    const uploadPromises = [];

    for (const [docType, file] of Object.entries(documents)) {
      if (file) {
        const uploadPromise = uploadDocument(
          file,
          docType,
          hospitalData.hospitalName
        );
        uploadPromises.push(
          uploadPromise.then((url) => {
            documentUrls[docType] = {
              url,
              fileName: file.name,
              size: file.size,
              uploadedAt: new Date(),
            };
          })
        );
      }
    }

    // Wait for all document uploads to complete
    await Promise.all(uploadPromises);

    // Prepare hospital data for Firestore with referral support
    const hospitalRecord = {
      // Basic Information
      hospitalName: hospitalData.hospitalName,
      address: hospitalData.address,
      city: hospitalData.city,
      state: hospitalData.state,
      pincode: hospitalData.pincode,
      phone: hospitalData.phone,
      email: hospitalData.email,
      website: hospitalData.website || "",

      // Hospital Details
      numberOfBeds: parseInt(hospitalData.numberOfBeds),
      facilities: hospitalData.facilities,
      specialities: hospitalData.specialities,
      pharmacyType: hospitalData.pharmacyType || "",
      dlNumber: hospitalData.dlNumber || "",
      hasNABH: hospitalData.hasNABH || false,
      hasQualityCouncil: hospitalData.hasQualityCouncil || false,

      // Registration Details
      registrationNumber: hospitalData.registrationNumber || "",
      registrationValidityDate: hospitalData.registrationValidityDate || "",

      // Representative Information (keeping original structure)
      representative: {
        name: hospitalData.mdAsRepresentative ? hospitalData.mdName : hospitalData.representativeName,
        designation: hospitalData.mdAsRepresentative ? "Managing Director" : hospitalData.designation,
        email: hospitalData.mdAsRepresentative ? hospitalData.mdEmail : hospitalData.representativeEmail,
        phone: hospitalData.mdAsRepresentative ? hospitalData.mdContact : hospitalData.representativePhone,
        isMD: hospitalData.mdAsRepresentative || false,
      },

      // MD Information (keeping original structure)
      managingDirector: {
        name: hospitalData.mdName,
        contact: hospitalData.mdContact,
        email: hospitalData.mdEmail || "",
      },

      // Account Information
      accountEmail: hospitalData.accountEmail,
      // Store password temporarily for approval process (will be removed after account creation)
      tempPassword: hospitalData.password,

      // Bank Details (keeping original structure)
      bankDetails: {
        bankName: hospitalData.bankName,
        accountNumber: hospitalData.accountNumber,
        ifscCode: hospitalData.ifscCode,
        accountHolderName: hospitalData.accountHolderName,
      },

      // Lead Generator Referral Information - NEW FEATURE
      referral: hospitalData.referredBy ? {
        leadGeneratorId: hospitalData.referredBy,
        leadGeneratorName: hospitalData.referredByName,
        leadGeneratorCity: hospitalData.referredByCity,
        referredAt: new Date(),
        isReferred: true,
      } : {
        isReferred: false,
        leadGeneratorId: null,
        leadGeneratorName: null,
        leadGeneratorCity: null,
        referredAt: null,
      },

      // Documents
      documents: documentUrls,

      // System fields (keeping original structure)
      status: "pending", // pending, approved, rejected
      applicationId: await generateApplicationId(),
      submittedAt: new Date(),
      createdAt: new Date(),
      updatedAt: new Date(),
      isActive: false, // Will be set to true when approved
      approvedBy: null,
      approvedAt: null,
      rejectionReason: null,
    };

    // Save to Firestore
    const docRef = await addDoc(
      collection(db, "hospitalApplications"),
      hospitalRecord
    );

    // If there's a referral, log it in the lead generator's record - NEW FEATURE
    if (hospitalData.referredBy) {
      try {
        await logReferralActivity(hospitalData.referredBy, {
          hospitalId: docRef.id,
          hospitalName: hospitalData.hospitalName,
          hospitalCity: hospitalData.city,
          hospitalState: hospitalData.state,
          applicationId: hospitalRecord.applicationId,
          referredAt: new Date(),
          status: "pending"
        });
      } catch (error) {
        console.error("Error logging referral activity:", error);
        // Don't fail the registration if referral logging fails
      }
    }

    return {
      success: true,
      applicationId: hospitalRecord.applicationId,
      docId: docRef.id,
      message: "Hospital registration submitted successfully!",
    };
  } catch (error) {
    console.error("Error registering hospital:", error);
    return {
      success: false,
      error: error.message || "Failed to register hospital",
    };
  }
};

// NEW FUNCTION - Log referral activity for lead generator
const logReferralActivity = async (leadGeneratorId, referralData) => {
  try {
    // Add to referral activities collection
    await addDoc(collection(db, "referralActivities"), {
      leadGeneratorId: leadGeneratorId,
      referralType: "hospital",
      referralData: referralData,
      createdAt: new Date(),
      updatedAt: new Date(),
    });

    // Update lead generator's referral stats
    const leadGenQuery = query(
      collection(db, "leadGeneratorApplications"),
      where("__name__", "==", leadGeneratorId)
    );

    const leadGenSnapshot = await getDocs(leadGenQuery);
    if (!leadGenSnapshot.empty) {
      const leadGenDoc = leadGenSnapshot.docs[0];
      const leadGenRef = doc(db, "leadGeneratorApplications", leadGenDoc.id);

      const currentData = leadGenDoc.data();
      const currentReferrals = currentData.referralStats || {
        totalReferrals: 0,
        hospitalReferrals: 0,
        pendingReferrals: 0,
        approvedReferrals: 0,
        rejectedReferrals: 0
      };

      await updateDoc(leadGenRef, {
        referralStats: {
          ...currentReferrals,
          totalReferrals: currentReferrals.totalReferrals + 1,
          hospitalReferrals: currentReferrals.hospitalReferrals + 1,
          pendingReferrals: currentReferrals.pendingReferrals + 1,
        },
        lastReferralAt: new Date(),
        updatedAt: new Date(),
      });
    }

    return { success: true };
  } catch (error) {
    console.error("Error logging referral activity:", error);
    return { success: false, error: error.message };
  }
};

// NEW FUNCTION - Update referral status when hospital application status changes
export const updateReferralStatus = async (hospitalId, newStatus, approvedBy = null) => {
  try {
    // Get hospital data first
    const hospitalDoc = await getDoc(doc(db, "hospitalApplications", hospitalId));
    if (!hospitalDoc.exists()) {
      return { success: false, error: "Hospital not found" };
    }

    const hospitalData = hospitalDoc.data();

    // If hospital has referral, update the referral status
    if (hospitalData.referral && hospitalData.referral.isReferred && hospitalData.referral.leadGeneratorId) {
      const leadGeneratorId = hospitalData.referral.leadGeneratorId;

      // Update referral activity status
      const referralQuery = query(
        collection(db, "referralActivities"),
        where("leadGeneratorId", "==", leadGeneratorId),
        where("referralData.hospitalId", "==", hospitalId)
      );

      const referralSnapshot = await getDocs(referralQuery);
      if (!referralSnapshot.empty) {
        const referralDoc = referralSnapshot.docs[0];
        const referralRef = doc(db, "referralActivities", referralDoc.id);

        await updateDoc(referralRef, {
          "referralData.status": newStatus,
          "referralData.statusUpdatedAt": new Date(),
          "referralData.approvedBy": approvedBy,
          updatedAt: new Date(),
        });
      }

      // Update lead generator referral stats
      const leadGenQuery = query(
        collection(db, "leadGeneratorApplications"),
        where("__name__", "==", leadGeneratorId)
      );

      const leadGenSnapshot = await getDocs(leadGenQuery);
      if (!leadGenSnapshot.empty) {
        const leadGenDoc = leadGenSnapshot.docs[0];
        const leadGenRef = doc(db, "leadGeneratorApplications", leadGenDoc.id);

        const currentData = leadGenDoc.data();
        const currentStats = currentData.referralStats || {
          totalReferrals: 0,
          hospitalReferrals: 0,
          pendingReferrals: 0,
          approvedReferrals: 0,
          rejectedReferrals: 0
        };

        let updatedStats = { ...currentStats };

        if (newStatus === "approved") {
          updatedStats.pendingReferrals = Math.max(0, updatedStats.pendingReferrals - 1);
          updatedStats.approvedReferrals = updatedStats.approvedReferrals + 1;
        } else if (newStatus === "rejected") {
          updatedStats.pendingReferrals = Math.max(0, updatedStats.pendingReferrals - 1);
          updatedStats.rejectedReferrals = (updatedStats.rejectedReferrals || 0) + 1;
        }

        await updateDoc(leadGenRef, {
          referralStats: updatedStats,
          updatedAt: new Date(),
        });
      }
    }

    return { success: true };
  } catch (error) {
    console.error("Error updating referral status:", error);
    return { success: false, error: error.message };
  }
};

// Upload document to Firebase Storage (keeping original)
export const uploadDocument = async (file, docType, hospitalName) => {
  try {
    const timestamp = Date.now();
    const uniqueToken = Math.random().toString(36).slice(2, 8);
    const fileName = `${docType}_${timestamp}_${uniqueToken}_${file.name}`;
    const storagePath = `hospitals/${hospitalName.replace(
      /\s+/g,
      "_"
    )}/documents/${fileName}`;

    const storageRef = ref(storage, storagePath);
    const snapshot = await uploadBytes(storageRef, file);
    const downloadURL = await getDownloadURL(snapshot.ref);

    return downloadURL;
  } catch (error) {
    console.error("Error uploading document:", error);
    throw new Error(`Failed to upload ${docType}: ${error.message}`);
  }
};

// Generate unique application ID (keeping original)
const generateApplicationId = async () => {
  try {
    const db = getFirestore();
    const counterRef = doc(db, 'counters', 'applicationId');
    
    // Use transaction to ensure atomicity
    const newId = await runTransaction(db, async (transaction) => {
      const counterDoc = await transaction.get(counterRef);
      
      let currentCount = 1;
      if (counterDoc.exists()) {
        currentCount = (counterDoc.data().count || 0) + 1;
      }
      
      // Update the counter
      transaction.set(counterRef, { count: currentCount, updatedAt: serverTimestamp() }, { merge: true });
      
      // Generate the application ID with padding (SAM00001, SAM00002, etc.)
      const paddedNumber = currentCount.toString().padStart(5, '0');
      return `SAM${paddedNumber}`;
    });
    
    return newId;
  } catch (error) {
    console.error('Error generating application ID:', error);
    // Fallback to timestamp-based ID if counter fails
    const timestamp = Date.now().toString().slice(-8);
    const random = Math.random().toString(36).substr(2, 4).toUpperCase();
    return `SAM${timestamp}${random}`;
  }
};

// Get all hospital applications (keeping original)
export const getHospitalApplications = async (status = null) => {
  try {
    let q = collection(db, "hospitalApplications");

    if (status) {
      q = query(q, where("status", "==", status));
    }

    q = query(q, orderBy("submittedAt", "desc"));

    const querySnapshot = await getDocs(q);
    const applications = [];

    querySnapshot.forEach((doc) => {
      applications.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return {
      success: true,
      applications,
    };
  } catch (error) {
    console.error("Error fetching hospital applications:", error);
    return {
      success: false,
      error: error.message,
      applications: [],
    };
  }
};

// Get single hospital application (keeping original)
export const getHospitalApplication = async (applicationId) => {
  try {
    const q = query(
      collection(db, "hospitalApplications"),
      where("applicationId", "==", applicationId)
    );

    const querySnapshot = await getDocs(q);

    if (querySnapshot.empty) {
      return {
        success: false,
        error: "Application not found",
      };
    }

    const doc = querySnapshot.docs[0];
    return {
      success: true,
      application: {
        id: doc.id,
        ...doc.data(),
      },
    };
  } catch (error) {
    console.error("Error fetching hospital application:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Approve hospital application (updated with referral status tracking)
export const approveHospitalApplication = async (
  applicationId,
  approvedBy
) => {
  try {
    // Get application data
    const appResult = await getHospitalApplication(applicationId);
    if (!appResult.success) {
      throw new Error("Application not found");
    }

    const application = appResult.application;

    // Use the password provided during registration
    const userPassword = application.tempPassword;
    
    if (!userPassword) {
      throw new Error("Account password not found in application");
    }

    // Create Firebase Auth user
    const userCredential = await createUserWithEmailAndPassword(
      secondaryAuth,
      application.accountEmail,
      userPassword
    );

    // Create user document in users collection (keeping original structure)
    const userData = {
      uid: userCredential.user.uid,
      email: application.accountEmail,
      role: "Hospital",
      hospitalId: application.id,
      hospitalName: application.hospitalName,
      isActive: true,
      createdAt: new Date(),
      profile: {
        name: application.representative.name,
        phone: application.representative.phone,
        designation: application.representative.designation,
      },
    };

    await setDoc(doc(db, "users", userCredential.user.uid), userData);

    // Update hospital application status
    const hospitalRef = doc(db, "hospitalApplications", application.id);
    await updateDoc(hospitalRef, {
      status: "approved",
      isActive: true,
      approvedBy: approvedBy,
      approvedAt: new Date(),
      updatedAt: new Date(),
      authUserId: userCredential.user.uid,
      // Remove the temporary password for security
      tempPassword: null,
    });

    // Update referral status if applicable - NEW FEATURE
    await updateReferralStatus(application.id, "approved", approvedBy);

    const result = {
      success: true,
      message: "Hospital approved successfully",
      userId: userCredential.user.uid,
    };
    
    try {
      // Avoid leaving the secondary auth signed-in (prevents background session growth)
      if (secondaryAuth.currentUser) {
        await secondaryAuth.signOut();
      }
    } catch {}
    
    return result;
  } catch (error) {
    console.error("Error approving hospital:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Reject hospital application (updated with referral status tracking)
export const rejectHospitalApplication = async (
  applicationId,
  rejectedBy,
  reason
) => {
  try {
    const appResult = await getHospitalApplication(applicationId);
    if (!appResult.success) {
      throw new Error("Application not found");
    }

    const hospitalRef = doc(
      db,
      "hospitalApplications",
      appResult.application.id
    );
    await updateDoc(hospitalRef, {
      status: "rejected",
      rejectedBy: rejectedBy,
      rejectedAt: new Date(),
      rejectionReason: reason,
      updatedAt: new Date(),
    });

    // Update referral status if applicable - NEW FEATURE
    await updateReferralStatus(appResult.application.id, "rejected", rejectedBy);

    return {
      success: true,
      message: "Hospital application rejected",
    };
  } catch (error) {
    console.error("Error rejecting hospital:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Request additional documents (keeping original)
export const requestAdditionalDocuments = async (
  applicationId,
  requestedBy,
  message,
  documents
) => {
  try {
    // First get the application
    const applicationResult = await getHospitalApplication(applicationId);
    if (!applicationResult.success) {
      return applicationResult;
    }

    const application = applicationResult.application;

    // Create a document request record
    const requestData = {
      applicationId: applicationId,
      hospitalId: application.id,
      hospitalName: application.hospitalName,
      requestedBy: requestedBy,
      message: message,
      requestedDocuments: documents,
      status: "pending",
      createdAt: new Date(),
      updatedAt: new Date(),
    };

    // Add to document requests collection
    await addDoc(collection(db, "documentRequests"), requestData);

    // Update application with request status
    const applicationDoc = doc(db, "hospitalApplications", application.id);
    await updateDoc(applicationDoc, {
      hasDocumentRequest: true,
      lastDocumentRequestAt: new Date(),
      updatedAt: new Date(),
    });

    return {
      success: true,
      message: "Document request sent successfully",
    };
  } catch (error) {
    console.error("Error requesting additional documents:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Get application statistics (updated with referral statistics)
export const getApplicationStats = async () => {
  try {
    const hospitalApplicationsRef = collection(db, "hospitalApplications");
    const patientApplicationsRef = collection(db, "patientApplications");

    // Get hospital application counts
    const totalHospitalQuery = await getDocs(hospitalApplicationsRef);
    const pendingHospitalQuery = await getDocs(
      query(hospitalApplicationsRef, where("status", "==", "pending"))
    );
    const approvedHospitalQuery = await getDocs(
      query(hospitalApplicationsRef, where("status", "==", "approved"))
    );
    const rejectedHospitalQuery = await getDocs(
      query(hospitalApplicationsRef, where("status", "==", "rejected"))
    );

    // Get patient application counts
    const totalPatientQuery = await getDocs(patientApplicationsRef);
    const pendingPatientQuery = await getDocs(
      query(patientApplicationsRef, where("status", "==", "submitted"))
    );
    const approvedPatientQuery = await getDocs(
      query(patientApplicationsRef, where("status", "==", "approved"))
    );

    // Calculate this month applications
    const currentMonth = new Date();
    currentMonth.setDate(1);
    currentMonth.setHours(0, 0, 0, 0);

    const thisMonthQuery = await getDocs(
      query(hospitalApplicationsRef, where("submittedAt", ">=", currentMonth))
    );

    // Calculate referral statistics - NEW FEATURE
    const referredApplicationsQuery = await getDocs(
      query(hospitalApplicationsRef, where("referral.isReferred", "==", true))
    );

    // Calculate average approval time (keeping original calculation)
    const approvedApps = approvedHospitalQuery.docs;
    let totalApprovalTime = 0;
    let approvalCount = 0;

    approvedApps.forEach((doc) => {
      const data = doc.data();
      if (data.submittedAt && data.approvedAt) {
        const submittedDate = data.submittedAt.toDate();
        const approvedDate = data.approvedAt.toDate();
        const timeDiff = (approvedDate - submittedDate) / (1000 * 60 * 60 * 24); // in days
        totalApprovalTime += timeDiff;
        approvalCount++;
      }
    });

    const averageApprovalTime =
      approvalCount > 0 ? Math.round(totalApprovalTime / approvalCount) : 0;

    return {
      success: true,
      stats: {
        // Hospital statistics (keeping original)
        totalApplications: totalHospitalQuery.size,
        pendingApplications: pendingHospitalQuery.size,
        approvedHospitals: approvedHospitalQuery.size,
        rejectedApplications: rejectedHospitalQuery.size,
        thisMonthApplications: thisMonthQuery.size,
        averageApprovalTime: averageApprovalTime,

        // Patient application statistics (keeping original)
        totalPatientApplications: totalPatientQuery.size,
        pendingPatientApplications: pendingPatientQuery.size,
        approvedPatientApplications: approvedPatientQuery.size,

        // Referral statistics - NEW FEATURE
        referredApplications: referredApplicationsQuery.size,
        referralRate: totalHospitalQuery.size > 0 ?
          Math.round((referredApplicationsQuery.size / totalHospitalQuery.size) * 100) : 0,
      },
    };
  } catch (error) {
    console.error("Error fetching application stats:", error);
    return {
      success: false,
      error: error.message,
      stats: {
        totalApplications: 0,
        pendingApplications: 0,
        approvedHospitals: 0,
        rejectedApplications: 0,
        thisMonthApplications: 0,
        averageApprovalTime: 0,
        totalPatientApplications: 0,
        pendingPatientApplications: 0,
        approvedPatientApplications: 0,
        referredApplications: 0,
        referralRate: 0,
      },
    };
  }
};

export const getLeadApplicationStats = async (userId) => {
  try {
    let hospitalApplicationsRef = collection(db, "hospitalApplications");
    let patientApplicationsRef = collection(db, "patientApplications");

    hospitalApplicationsRef = query(hospitalApplicationsRef, where("referral.leadGeneratorId", "==", userId));
    patientApplicationsRef = query(patientApplicationsRef, where("leadGenerator.id", "==", userId));
    // Get hospital application counts
    const totalHospitalQuery = await getDocs(hospitalApplicationsRef);
    const pendingHospitalQuery = await getDocs(
      query(hospitalApplicationsRef, where("status", "==", "pending"))
    );
    const approvedHospitalQuery = await getDocs(
      query(hospitalApplicationsRef, where("status", "==", "approved"))
    );
    const rejectedHospitalQuery = await getDocs(
      query(hospitalApplicationsRef, where("status", "==", "rejected"))
    );

    // Get patient application counts
    const totalPatientQuery = await getDocs(patientApplicationsRef);
    const pendingPatientQuery = await getDocs(
      query(patientApplicationsRef, where("status", "==", "submitted"))
    );
    const approvedPatientQuery = await getDocs(
      query(patientApplicationsRef, where("status", "==", "approved"))
    );

    // Calculate this month applications
    const currentMonth = new Date();
    currentMonth.setDate(1);
    currentMonth.setHours(0, 0, 0, 0);

    const thisMonthQuery = await getDocs(
      query(hospitalApplicationsRef, where("submittedAt", ">=", currentMonth))
    );

    // Calculate referral statistics - NEW FEATURE
    const referredApplicationsQuery = await getDocs(
      query(hospitalApplicationsRef, where("referral.isReferred", "==", true))
    );

    // Calculate average approval time (keeping original calculation)
    const approvedApps = approvedHospitalQuery.docs;
    let totalApprovalTime = 0;
    let approvalCount = 0;

    approvedApps.forEach((doc) => {
      const data = doc.data();
      if (data.submittedAt && data.approvedAt) {
        const submittedDate = data.submittedAt.toDate();
        const approvedDate = data.approvedAt.toDate();
        const timeDiff = (approvedDate - submittedDate) / (1000 * 60 * 60 * 24); // in days
        totalApprovalTime += timeDiff;
        approvalCount++;
      }
    });

    const averageApprovalTime =
      approvalCount > 0 ? Math.round(totalApprovalTime / approvalCount) : 0;

    return {
      success: true,
      stats: {
        // Hospital statistics (keeping original)
        totalApplications: totalHospitalQuery.size,
        pendingApplications: pendingHospitalQuery.size,
        approvedHospitals: approvedHospitalQuery.size,
        rejectedApplications: rejectedHospitalQuery.size,
        thisMonthApplications: thisMonthQuery.size,
        averageApprovalTime: averageApprovalTime,

        // Patient application statistics (keeping original)
        totalPatientApplications: totalPatientQuery.size,
        pendingPatientApplications: pendingPatientQuery.size,
        approvedPatientApplications: approvedPatientQuery.size,

        // Referral statistics - NEW FEATURE
        referredApplications: referredApplicationsQuery.size,
        referralRate: totalHospitalQuery.size > 0 ?
          Math.round((referredApplicationsQuery.size / totalHospitalQuery.size) * 100) : 0,
      },
    };
  } catch (error) {
    console.error("Error fetching application stats:", error);
    return {
      success: false,
      error: error.message,
      stats: {
        totalApplications: 0,
        pendingApplications: 0,
        approvedHospitals: 0,
        rejectedApplications: 0,
        thisMonthApplications: 0,
        averageApprovalTime: 0,
        totalPatientApplications: 0,
        pendingPatientApplications: 0,
        approvedPatientApplications: 0,
        referredApplications: 0,
        referralRate: 0,
      },
    };
  }
};

// Get hospitals by referrer (for lead generators)
export const getHospitalsByReferrer = async (leadGeneratorId) => {
  try {
    const hospitalsQuery = query(
      collection(db, "hospitalApplications"),
      where("referral.leadGeneratorId", "==", leadGeneratorId),
      orderBy("createdAt", "desc")
    );

    const querySnapshot = await getDocs(hospitalsQuery);
    const hospitals = [];

    querySnapshot.forEach((doc) => {
      hospitals.push({
        id: doc.id,
        ...doc.data(),
      });
    });

    return {
      success: true,
      hospitals,
    };
  } catch (error) {
    console.error("Error fetching hospitals by referrer:", error);
    return {
      success: false,
      error: error.message,
      hospitals: [],
    };
  }
};

// Get lead generator referral stats
export const getLeadGeneratorReferralStats = async (leadGeneratorId) => {
  try {
    const hospitalsQuery = query(
      collection(db, "hospitalApplications"),
      where("referral.leadGeneratorId", "==", leadGeneratorId)
    );

    const querySnapshot = await getDocs(hospitalsQuery);
    const stats = {
      totalReferrals: 0,
      pendingApproval: 0,
      approved: 0,
      rejected: 0,
      totalCommission: 0,
    };

    querySnapshot.forEach((doc) => {
      const data = doc.data();
      stats.totalReferrals++;

      switch (data.status) {
        case "pending":
          stats.pendingApproval++;
          break;
        case "approved":
          stats.approved++;
          if (data.commission) {
            stats.totalCommission += data.commission;
          }
          break;
        case "rejected":
          stats.rejected++;
          break;
      }
    });

    return {
      success: true,
      stats,
    };
  } catch (error) {
    console.error("Error fetching lead generator stats:", error);
    return {
      success: false,
      error: error.message,
      stats: {
        totalReferrals: 0,
        pendingApproval: 0,
        approved: 0,
        rejected: 0,
        totalCommission: 0,
      },
    };
  }
};

// Update hospital profile
export const updateHospitalProfile = async (hospitalId, updateData) => {
  try {
    const hospitalRef = doc(db, "hospitalApplications", hospitalId);
    await updateDoc(hospitalRef, {
      ...updateData,
      updatedAt: new Date(),
    });

    return {
      success: true,
      message: "Hospital profile updated successfully",
    };
  } catch (error) {
    console.error("Error updating hospital profile:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Delete document from storage
export const deleteDocument = async (documentUrl) => {
  try {
    const storageRef = ref(storage, documentUrl);
    await deleteObject(storageRef);

    return {
      success: true,
      message: "Document deleted successfully",
    };
  } catch (error) {
    console.error("Error deleting document:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// // Get recent activities for admin dashboard
// export const getRecentActivities = async (limit = 10) => {
//   try {
//     const hospitalQuery = query(
//       collection(db, "hospitalApplications"),
//       orderBy("updatedAt", "desc"),
//       limit(limit)
//     );

//     const querySnapshot = await getDocs(hospitalQuery);
//     const activities = [];

//     querySnapshot.forEach((doc) => {
//       const data = doc.data();
//       activities.push({
//         id: doc.id,
//         type: "hospital",
//         action: data.status,
//         hospitalName: data.hospitalName,
//         timestamp: data.updatedAt,
//         details: data,
//       });
//     });

//     return {
//       success: true,
//       activities,
//     };
//   } catch (error) {
//     console.error("Error fetching recent activities:", error);
//     return {
//       success: false,
//       error: error.message,
//       activities: [],
//     };
//   }
// };

// export const deactivateHospital = async (hospitalId, deactivatedBy, reason) => {
//   try {
//     const hospitalDoc = doc(db, "hospitalApplications", hospitalId);
//     await updateDoc(hospitalDoc, {
//       isActive: false,
//       deactivatedBy: deactivatedBy,
//       deactivatedAt: new Date(),
//       deactivationReason: reason,
//       updatedAt: new Date(),
//     });

//     return {
//       success: true,
//       message: "Hospital deactivated successfully",
//     };
//   } catch (error) {
//     console.error("Error deactivating hospital:", error);
//     return {
//       success: false,
//       error: error.message,
//     };
//   }
// };
// Initiate discharge process
export const initiateDischargeProcess = async (applicationId) => {
  try {
    // First find the actual document by applicationId
    const applicationsQuery = query(
      collection(db, "patientApplications"),
      where("applicationId", "==", applicationId)
    );

    const querySnapshot = await getDocs(applicationsQuery);

    if (querySnapshot.empty) {
      return {
        success: false,
        error: "Application not found",
      };
    }

    // Get the actual document ID
    const applicationDoc = querySnapshot.docs[0];
    const actualDocId = applicationDoc.id;

    // Update the document using the actual Firestore document ID
    const applicationRef = doc(db, "patientApplications", actualDocId);
    await updateDoc(applicationRef, {
      dischargeInitiated: true,
      dischargeInitiatedAt: new Date(),
      dischargeStatus: "initiated",
      updatedAt: new Date(),
    });

    return {
      success: true,
      message: "Discharge process initiated successfully",
    };
  } catch (error) {
    console.error("Error initiating discharge process:", error);
    return {
      success: false,
      error: error.message,
    };
  }
};

// Get hospital tariff documents by hospital ID
export const getHospitalTariffDocuments = async (hospitalId) => {
  try {
    // First try to get hospital by document ID
    let hospitalDoc;
    try {
      hospitalDoc = await getDoc(doc(db, "hospitalApplications", hospitalId));
    } catch (error) {
      // If that fails, search by hospital name or other identifier
      const hospitalQuery = query(
        collection(db, "hospitalApplications"),
        where("hospitalName", "==", hospitalId),
        where("status", "==", "approved"),
        limit(1)
      );
      const hospitalSnapshot = await getDocs(hospitalQuery);
      
      if (!hospitalSnapshot.empty) {
        hospitalDoc = hospitalSnapshot.docs[0];
      }
    }

    if (!hospitalDoc || !hospitalDoc.exists()) {
      return {
        success: false,
        error: "Hospital not found",
        tariffDocuments: null,
      };
    }

    const hospitalData = hospitalDoc.data();
    const documents = hospitalData.documents || {};

    // Extract tariff documents
    const tariffDocuments = {
      roomTariff: documents.roomTariff || null,
      procedureTariff: documents.procedureTariff || null,
      hospitalName: hospitalData.hospitalName,
      hospitalId: hospitalDoc.id,
    };

    return {
      success: true,
      tariffDocuments,
    };
  } catch (error) {
    console.error("Error fetching hospital tariff documents:", error);
    return {
      success: false,
      error: error.message,
      tariffDocuments: null,
    };
  }
};